import ApiService from "../../api/api.service";
import { REGISTRATION_DATA, VERIFY_EMAIL_OTP, VERIFY_MOBILE_OTP, USER_SIGNIN, GET_PROFILE_DETAIL, UPDATE_PROFILE_DETAIL, GET_REFERRAL_DETAIL,
 CREATE_DEFAULT_SUBSCRIPTION, GET_USER_PLAN_DETAIL, CREATE_USER_PLAN_SUBSCRIPTION, VERIFY_RAZORPAY_SIGNATURE,
 USER_SIGNOUT, USER_DETAILS, UPDATE_USER_DETAILS,SEND_MOBILE_OTP } from "../actions.type";

const getDefaultDepositState = () => {
	return {
		registrationData: {},
		verifyEmailOtp: {},
		verifyMobileOtp: {},
		userSignin: {}, 
		profileDetail: {},
		referralDetail: {},
		createDefaultSubscription: {},
		getUserPlanDetail: {},
		createUserPlanSubscription: {},
		verifyRazorpaySignature: {},
		userSignout: {},
		userDetails: {},
	}
};

const state = getDefaultDepositState();

const getters = {

	getRegistrationData(state) {
		return state.registrationData;
	},
	getVerifyEmailOtp(state) {
		return state.verifyEmailOtp;
	},
	getVerifyMobileOtp(state) {
		return state.verifyMobileOtp;
	},
	getUserSignin(state){
		return state.userSignin;
	},
	getProfileDetail(state){
		return state.profileDetail;
	},
	getReferralDetail(state){
		return state.referralDetail;
	},
	getDefaultSubscription(state){
		return state.createDefaultSubscription;
	},
	getUserPlanDetail(state){
		return state.getUserPlanDetail;
	},
	getUserPlanSubscription(state){
		return state.createUserPlanSubscription;
	},
	getVerifyRazorpaySignature(state){
		return state.verifyRazorpaySignature;
	},
	getUserSignout(state){
		return state.userSignout;
	},
	getUserDetails(state){
		return state.userDetails;
	}

};

const mutations = {

	setRegistrationData (state, data) {
		state.registrationData = data
	},
	setVerifyEmailData (state, data) {
		state.verifyEmailOtp = data
	},
	setVerifyMobileOtp (state, data) {
		state.verifyMobileOtp = data
	},
	setUserSignin (state, data) {
		state.userSignin = data
	},
	setProfileDetail (state, data) {
		state.profileDetail = data
	},
	setUpdateProfileDetail (state, data) {
		state.profileDetail.data[data.key] = data.value
	},
	setReferralDetail (state, data) {
		state.referralDetail = data
	},
	setDefaultSubscription (state, data) {
		state.createDefaultSubscription = data
	},
	setUserPlanDetail (state, data) {
		state.getUserPlanDetail = data
	},
	setUserPlanSubscription (state, data) {
		state.createUserPlanSubscription = data
	},
	setVerifyRazorpaySignature (state, data) {
		state.verifyRazorpaySignature = data
	},
	setUserSignout (state, data) {
		state.userSignout = data
	},
	setUserDetails (state, data) {
		state.userDetails = data
	},
	setUpdateUserDetails (state, data) {
		state.userDetails[data.key] = data.value
	},

};


const actions = {

	[REGISTRATION_DATA](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();

			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setRegistrationData',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{

				window.location.replace('/');

			}
			console.log("Something went wrong");
		});
	},

	[VERIFY_EMAIL_OTP](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();

			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setVerifyEmailData',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{

				window.location.replace('/');

			}
			console.log("Something went wrong");
		});
	},

	[VERIFY_MOBILE_OTP](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();

			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setVerifyMobileOtp',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{

				window.location.replace('/');

			}
			console.log("Something went wrong");
		});
	},
	[USER_SIGNIN](context, credentials){
		return new Promise((resolve, reject) => {

			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setUserSignin',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{

				window.location.replace('/');

			}
			console.log("Something went wrong");
		});
	},
	[GET_PROFILE_DETAIL](context, credentials){
		return new Promise((resolve, reject) => {
			ApiService.setHeader();

			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setProfileDetail',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{

				window.location.replace('/');

			}
			console.log("Something went wrong");
		});
	},
	[UPDATE_PROFILE_DETAIL](context, credentials){
		credentials.forEach(element => {
			context.commit('setUpdateProfileDetail',element);
		})
	},
	[GET_REFERRAL_DETAIL](context, credentials){
		return new Promise((resolve, reject) => {
			ApiService.setHeader();

			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					// wind	ow.location.replace('/');
				}
				context.commit('setReferralDetail',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{

				window.location.replace('/');

			}
			console.log("Something went wrong");
		});
	},
	[CREATE_DEFAULT_SUBSCRIPTION](context, credentials){
		return new Promise((resolve, reject) => {
			ApiService.setHeader();

			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setDefaultSubscription',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{

				window.location.replace('/');

			}
			console.log("Something went wrong");
		});
	},
	[GET_USER_PLAN_DETAIL](context, credentials){
		return new Promise((resolve, reject) => {
			ApiService.setHeader();

			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setUserPlanDetail',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{

				window.location.replace('/');

			}
			console.log("Something went wrong");
		});
	},
	[CREATE_USER_PLAN_SUBSCRIPTION](context, credentials){
		return new Promise((resolve, reject) => {
			ApiService.setHeader();

			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setUserPlanSubscription',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{

				window.location.replace('/');

			}
			console.log("Something went wrong");
		});
	},
	[VERIFY_RAZORPAY_SIGNATURE](context, credentials){
		return new Promise((resolve, reject) => {
			ApiService.setHeader();

			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setVerifyRazorpaySignature',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{

				window.location.replace('/');

			}
			console.log("Something went wrong");
		});
	},
	[USER_SIGNOUT](context, credentials){
		return new Promise((resolve, reject) => {
			ApiService.setHeader();

			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setUserSignout',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{

				window.location.replace('/');

			}
			console.log("Something went wrong");
		});
	},
	[USER_DETAILS](context, credentials){
		context.commit('setUserDetails',credentials);
	},
	[UPDATE_USER_DETAILS](context, credentials){
		credentials.forEach(element => {
			context.commit('setUpdateUserDetails',element);
		})
	},

};

export default {
	getters,
	actions,
	mutations,
	state
}